(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/payment/assets/javascripts/api/jupiter/numbergames/dialogs/payment-confirm-next-draw.js') >= 0) return;  svs.modules.push('/components/tur/payment/assets/javascripts/api/jupiter/numbergames/dialogs/payment-confirm-next-draw.js');
'use strict';

class PaymentConfirmNextDraw extends svs.tur.payment.dialogs.PaymentConfirm {
  getIcon() {
    return 'exclamation-sign';
  }
  getTitle() {
    return 'Ojdå! Omgången hann stänga för spel!';
  }
  getMessage() {
    if (svs.numbergames.productMapping.isLotto(this.upcomingDrawProduct)) {
      const dayName = this.dayToLowerCase(svs.numbergames.productMapping.getProductDayName(this.upcomingDrawProduct));
      const closedDayName = this.getClosedDayName(this.upcomingDrawProduct);
      const nextOpenTime = this.upcomingDrawProduct === 'ONSLOTTO' ? '18:30' : '18:00';
      return [{
        type: svs.components.dialog.message.TEXT,
        text: "".concat(closedDayName, " \xF6ppnar igen f\xF6r spel kl ").concat(nextOpenTime, "<br />\n                Vill du spela p\xE5 ").concat(dayName, " ist\xE4llet? "),
        align: svs.components.dialog.message.align.CENTER
      }];
    }
    const formattedDate = svs.utils.date.FormatTime('d/M', this.nextDrawDate);
    return [{
      type: svs.components.dialog.message.TEXT,
      text: "Vill du spela p\xE5 n\xE4stkommande omg\xE5ng (".concat(formattedDate, ") ist\xE4llet?"),
      align: svs.components.dialog.message.align.CENTER
    }];
  }

  getClosedDayName(upcomingDrawProduct) {
    const closedDay = upcomingDrawProduct === 'ONSLOTTO' ? 'LORLOTTO' : 'ONSLOTTO';
    return this.dayToLowerCase(svs.numbergames.productMapping.getProductDayName(closedDay));
  }

  dayToLowerCase(dayString) {
    return dayString.replace(/\w.[A-Z]/, $1 => $1.toLowerCase());
  }
}
svs.tur.payment.api.jupiter.numbergames.dialogs.PaymentConfirmNextDraw = PaymentConfirmNextDraw;

 })(window);